// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, {PropTypes} from 'react';
import cx from 'classnames';
import _ from 'lodash';
import moment from 'moment';

// utilities
import {lookup,} from '../../../../../../redux/helpers/staticData';
import prettyDate from '../../../../../../lib/prettyDate';
import prettyTime from '../../../../../../lib/prettyTime';


export default function EventsList(props) {

  const contactStatusKeyById = _.keyBy(props.staticData.contactStatus, 'id');

  function click(index, list){
    props.handleClick(index, list);
  }

  function toggle(index){
    props.toggleNoteMessage(index);
  }

  return (
    <ol
      data-id='Event List'
      className='event-list'

    >
      {
        props.list.map((event, eventIndex) =>
          <div
            data-id={`Event List Item ${eventIndex}`}
            className={cx('event-list-item', {'note-item': event.isNote, 'task-item': !event.isNote})}
            key={eventIndex}
          >
            <div
              className='event-status'
              style={{
                backgroundColor: _.get(contactStatusKeyById, `${event.contactStatusId}.color`) || '#4a4a4a'
              }}
            />
            <div className='event-timestamp'>
              <div className='event-header'>
                <div data-id='Event Date' className='event-date noTextSelect'>
                  {prettyDate(new Date(event.dateCreated))}
                </div>
                <div>
                  {event.taskTypeName && event.taskTypeName}
                </div>
                {!event.isNote
                  &&
                  <div
                    data-id='Event Open'
                    className='event-open noTextSelect'
                  >
                    {event.closed ? 'Closed' : 'Open'}
                  </div>
                }
              </div>
              <div
                data-id='Event Time'
                className='event-time noTextSelect hover-link'
                onClick={click.bind(this, eventIndex, props.list)}
              >
                {event.isNote ? lookup(props.staticData, 'contactNoteTypes', {id: event.noteTypeId}) : lookup(props.staticData, 'contactTaskResultTypes', {id: event.taskResultId})} {prettyTime(new Date(event.dateCreated))}
              </div>
            </div>
            <div className='event-content'>
              <div
                data-id='Event Description'
                className='event-description noTextSelect'
                onClick={toggle.bind(this, eventIndex)}
              >
                {!event.closed && event.taskTypeId && event.taskTypeId !== 3 && !_.isNil(event.taskFollowUpDate) ? `Follow up on ${moment(event.taskFollowUpDate).format('L')}` : ''}
                {event.note ? (event.dateModified ? 'Note Edited' : 'Note Added') : ''}
              </div>
              {
                event.message
                &&
                <div
                  data-id='Note Sub-Description'
                  className='note-details noTextSelect'
                >
                  <pre>
                    {event.message}
                  </pre>
                </div>
              }

              <div className='event-author note-details'>
                  - {event.createdBy.name || `${props.user.firstName} ${props.user.lastName}`}
              </div>
            </div>
          </div>
        )
      }
    </ol>
  );
}

EventsList.propTypes = {
  list: PropTypes.array,
  state: PropTypes.object,
  category: PropTypes.string,
  contactStatusId: PropTypes.number,
  staticData: PropTypes.object
};

EventsList.defaultProps = {
  list: [],
  state: {}
};



// WEBPACK FOOTER //
// ./shared/react/admin/Contact/Worksheet/Events/EventsList/index.js